
/**
 * Front size utilities.
 * inclusiveFrontsStartPage(isMobile) - set initial font size and active button
 * inclusiveFrontSize(isMobile) - attach listeners; returns cleanup function
 */

var baseFontSize = 10;
var percentSizeBig = 1.5;
var percentSizeLarge = 2;
var fontSizeBig = baseFontSize * percentSizeBig;
var fontSizeLarge = baseFontSize * percentSizeLarge;
var root = document.documentElement;

function removeClassFromAllElements(selector) {
  var elements = document.querySelectorAll("." + selector);
  for (var i = 0; i < elements.length; i++) {
    elements[i].classList.remove(selector);
  }
}

export function inclusiveFrontsStartPage(isMobileScreen) {
  var saved = parseFloat(localStorage.getItem("access_font")) || baseFontSize;
  root.style.fontSize = saved + "px";

  if (saved === fontSizeBig) {
    removeClassFromAllElements("inclusive-panel-size-btns-item-active");
    var btn = isMobileScreen ? document.getElementById("font-big-mob") : document.getElementById("font-big");
    if (btn) btn.classList.add("inclusive-panel-size-btns-item-active");
  } else if (saved === fontSizeLarge) {
    removeClassFromAllElements("inclusive-panel-size-btns-item-active");
    var btn2 = isMobileScreen ? document.getElementById("font-large-mob") : document.getElementById("font-large");
    if (btn2) btn2.classList.add("inclusive-panel-size-btns-item-active");
  }
}

export function inclusiveFrontSize(isMobileScreen) {
  var btnDefault = isMobileScreen ? document.getElementById("font-default-mob") : document.getElementById("font-default");
  var btnBig = isMobileScreen ? document.getElementById("font-big-mob") : document.getElementById("font-big");
  var btnLarge = isMobileScreen ? document.getElementById("font-large-mob") : document.getElementById("font-large");

  var listeners = [];

  function on(el, ev, handler) {
    if (!el) return;
    el.addEventListener(ev, handler);
    listeners.push({ el: el, ev: ev, handler: handler });
  }
  function offAll() {
    for (var i = 0; i < listeners.length; i++) {
      try {
        var it = listeners[i];
        it.el.removeEventListener(it.ev, it.handler);
      } catch (e) {}
    }
    listeners = [];
  }

  function changeFontSize(size, element) {
    var newSize = baseFontSize;
    removeClassFromAllElements("inclusive-panel-size-btns-item-active");
    if (size === "big") newSize = fontSizeBig;
    if (size === "large") newSize = fontSizeLarge;
    if (element) element.classList.add("inclusive-panel-size-btns-item-active");
    root.style.fontSize = newSize + "px";
    localStorage.setItem("access_font", newSize + "px");
  }

  on(btnDefault, "click", function () { changeFontSize("default", btnDefault); });
  on(btnBig, "click", function () { changeFontSize("big", btnBig); });
  on(btnLarge, "click", function () { changeFontSize("large", btnLarge); });

  return function cleanup() {
    offAll();
  };
}



// WEBPACK FOOTER //
// src/components/inclusive/utils/inclusiveFrontSize.js